/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coach_CloseInputs */

const en_us2_coach_close = /** @type {(inputs: Coach_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Close the trainer`)
};

const pt_br2_coach_close = /** @type {(inputs: Coach_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fechar o personal`)
};

const es_419_coach_close = /** @type {(inputs: Coach_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cerrar el entrenador`)
};

const pt_pt2_coach_close = /** @type {(inputs: Coach_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fechar o treinador`)
};

const fr_fr2_coach_close = /** @type {(inputs: Coach_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fermer le coach`)
};

const de_de2_coach_close = /** @type {(inputs: Coach_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Coach schließen`)
};

const it_it2_coach_close = /** @type {(inputs: Coach_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chiudi il coach`)
};

/**
* | output |
* | --- |
* | "Close the trainer" |
*
* @param {Coach_CloseInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const coach_close = /** @type {((inputs?: Coach_CloseInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coach_CloseInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_coach_close(inputs)
	if (locale === "es-419") return es_419_coach_close(inputs)
	if (locale === "pt-PT") return pt_pt2_coach_close(inputs)
	if (locale === "fr-FR") return fr_fr2_coach_close(inputs)
	if (locale === "de-DE") return de_de2_coach_close(inputs)
	if (locale === "it-IT") return it_it2_coach_close(inputs)
	return en_us2_coach_close(inputs)
});
export { coach_close as "coach.close" }